import { track } from '@amplitude/unified'
import React, { useEffect } from 'react'
import Footer from '../Partials/Footer'
import Header from '../Partials/Header'
import ContactUs from './ContactUs'


export default function Product() {
  const playerRef = React.useRef(null);

  useEffect(() => {
    track('Page Viewed', { pageName: 'Product' });

    // load YouTube IFrame API if not already loaded
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // create player when API is ready
    window.onYouTubeIframeAPIReady = () => {
      playerRef.current = new window.YT.Player('surya-walkthrough', {
        height: '315',
        width: '560',
        videoId: '3McyClhOIjE',
        events: {
          onStateChange: onPlayerStateChange,
        },
        playerVars: {
          rel: 0,
          modestbranding: 1,
        },
      });
    };

    function onPlayerStateChange(event) {
      const state = event.data;
      const currentTime = playerRef.current && typeof playerRef.current.getCurrentTime === 'function'
        ? Math.floor(playerRef.current.getCurrentTime())
        : null;

      if (state === window.YT.PlayerState.PLAYING) {
        track('YouTube Video Played', {
          videoId: '3McyClhOIjE',
          videoTitle: 'Surya Walkthrough video',
          currentTime,
        });
      } else if (state === window.YT.PlayerState.PAUSED) {
        track('YouTube Video Paused', {
          videoId: '3McyClhOIjE',
          videoTitle: 'Surya Walkthrough video',
          currentTime,
        });
      }
    }
  }, []);

  return (
    <>
      <div className="product--topbg"></div>
        <Header />
        <section className="product--top">
          <div className="container">
            <div className="product--container">
              <div className="product__logo">
                <img src="/images/Rishi_Surya_logo.png" alt="" />
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className='prdoduct--details'>
                    <div className="product__header">
                      <h1>Accelerate and optimse solar installs with Surya</h1>
                    </div>
                    <div className="product__subheading mt-5">
                      <h4>The only Digital Construction platform purpose-built for utility-scale solar farms. Surya is used to digitise construction workflows for both fixed tilt and tracker technologies.</h4>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 d-flex align-items-end">
                  <div className="product__img">
                    <img src="/images/product1.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


      <section className="surya">
        <div style={{minWidth:"100%",display:"flex", justifyContent:"center"}} className="container">            
              {/* <div className="surya__logo">
                <img src="/images/suryalogo.png" alt="" height={52} width={135} />
              </div>
              <div className="surya__paragraph">
                <p>Our launch version v1.0 enables customers working on projects with Nextracker Technology to</p>
              </div> */}

              <div style={{display:"flex", flexWrap:"wrap", justifyContent: "center",maxWidth:"2000px", alignItems:"center"}}>
              <div className="col-sm-12 col-md-6 col-lg-6 leftCards">
                <div className="surya--box leftCard" data-aos="fade-up"
                                            data-aos-offset="3"
                                            data-aos-delay="15"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out">
                  <div className="surya--topic">
                    <div className="success--logo">
                      <svg fill="#F26654" style={{minWidth:"30px",minHeight:"30px"}} class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiTab-iconWrapper MuiTab-icon css-1yi2vj5" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="m13.7826 15.1719 2.1213-2.1213 5.9963 5.9962-2.1213 2.1213zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49c-1.17-1.17-3.07-1.17-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21"></path></svg>
                    </div>
                    <h3 style={{display: "contents"}}>Visualise</h3>
                  </div>
                  <div className="surya__list d-flex align-items-center mt-4">
                    <div className="success--paragraph">
                      <p>Record and monitor construction progress across the site using Surya’s Interactive Digital Twin – Providing a live, spatial view of activities as they unfold.</p>
                      <br/><p>This gives EPCs and developers real-time visibility, enabling predictive insights and faster decision-making to keep projects on schedule.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="surya--box leftCard" data-aos="fade-up"
                                            data-aos-offset="3"
                                            data-aos-delay="15"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out">
                  <div className="surya--topic">
                    <div className="success--logo">
                      <svg fill="#F26654" style={{minWidth:"30px",minHeight:"30px"}} class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiTab-iconWrapper MuiTab-icon css-1yi2vj5" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m13.5-9 1.96 2.5H17V9.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"></path></svg>
                    </div>
                    <h3 style={{display: "contents"}}>Plan</h3>
                  </div>
                  <div className="surya__list d-flex align-items-center mt-4">
                    <div className="success--paragraph">
                      <p>Track and trace materials from delivery to installation with full visibility. Every movement creates a traceable digital footprint, providing a complete audit trail for compliance and accountability. Manage site laydowns, inventories, and material storage – all in one integrated platform. </p>
                      <br/><p>This reduces delays, prevents stockouts, and optimises supply chain efficiency for smoother project execution.</p>
                    </div>
                  </div>
                </div>

                <div className="surya--box leftCard" data-aos="fade-up"
                                            data-aos-offset="3"
                                            data-aos-delay="15"
                                            data-aos-duration="1000"
                                            data-aos-easing="ease-in-out">
                  <div className="surya--topic">
                    <div className="success--logo">
                      <svg fill="#F26654" style={{minWidth:"30px",minHeight:"30px"}} class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiTab-iconWrapper MuiTab-icon css-1yi2vj5" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9z"></path></svg>
                    </div>
                    <h3 style={{display: "contents"}}>Assure</h3>
                  </div>
                  <div className="surya__list d-flex align-items-center mt-4">
                    <div className="success--paragraph">
                      <p>Streamline quality checks with Surya’s geolocation-enabled Tablet App. Access checklists, log issues, capture photos, and share updates instantly for faster action. </p>
                      <br/><p>This ensures traceable quality data, enabling early defect detection and resolution – minimising costly rework and improving compliance.</p>
                    </div>
                  </div>
                </div>

            </div>
            <img className="threescreen--img" src="/images/about2.png" alt="" />
          </div>
        </div>
      </section>

      {/* <section className='why--surya'>
        <div className="container">
          <div className="surya--header">
            <h2>Why use Surya</h2>
          </div>
          <div className="surya--paragraph mt-4">
            <p>Simple, imagine a software which is custom-built, not just for your industry but for your specific project. That’s what we offer, contact us for a demo</p>
          </div>
        </div>
      </section> */}

      <section className='walkthrough'>
        <div className="container">
          <div style={{"paddingBottom":"20px"}} className="about__header">
            <h2>Surya Walkthrough video</h2>
          </div>
          <div id="yt-player-container">
            <div id="surya-walkthrough"></div>
          </div>
        </div>
      </section>

      {/* <section className='member'>
        <div className="container">
          <div className="member--header">
            <h2>Why become a member of Surya</h2>
          </div>
          <div className="row mt-15">
            <div className="col-sm-12 col-md-4 col-lg-4">
              <div className="member-box">
                <div className="member--icon">
                  <img src="/images/data.png" alt="" />
                </div>
                <div className="member--header">
                  <h3>Data Valuation Platform</h3>
                </div>
                <div className="member--paragraph mt-3">
                  <p>Apart from using the services on our platform, Surya will be the first ever data valuation platform operating in a large scale B2B environment.</p>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-4 col-lg-4">
              <div className="member-box">
                <div className="member--icon">
                  <img src="/images/benefit.png" alt="" />
                </div>
                <div className="member--header">
                  <h3>Derive Monetary Benefits</h3>
                </div>
                <div className="member--paragraph mt-3">
                  <p>What’s more, companies could also derive direct monetary benefits by sharing their project specific data on our platform.</p>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-4 col-lg-4">
              <div className="member-box">
                <div className="member--icon">
                  <img src="/images/reaily.png" alt="" />
                </div>
                <div className="member--header">
                  <h3>Readily Available Data for Use</h3>
                </div>
                <div className="member--paragraph mt-3">
                  <p>Companies working on a project would be able to reap maximum benefits of having non-confidential project specific data readily available for use.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section> */}

      {/* <section className="data">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="data--header">
                <h2>Data security</h2>
              </div>
              <div className="data--paragraph mt-5">
                <p>Your data security is our highest priority. Our company and the platform SURYA are assessed and conform to the requirements of <span onClick={() => setModalShow(true)}>ISO 27001:2013</span> (Information security management system).
                  <br />
                  <br />
                  Yes, we are a startup but data security and compliance is where we spent first. We shunned the idea of building an MVP (Minimum viable product) or rather we interpreted it as Maximum Viable Product to offer you a fully functional & complete product with the necessary security systems in place.
                  <br />
                  <br />
                  That’s not all, we have plans to become SOC 2 compliant in 2023. Rest assured, the product will have the highest data security standards in line and most likely better than industry standards.
                </p>
                <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
              </div>
              
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 d-flex align-items-center">
              <div className="data--img">
                <img src="/images/security.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='certificate' id='certificate'>
        <div className="container">
          <div className="certificate--box" onClick={() => setModalShow(true)}>
            <div className="certificate--container">
              <div className="certificate__img">
                <img src="/images/iso.png" alt="" height={119} width={119} />
              </div>
              <div className="certificate__details">
                <h5>Certificate Number</h5>
                <h3>BQSR2042</h3>
              </div>
            </div>
            <div className="certificate__arrow">
              <img src="/images/arrow.png" alt="" />
            </div>
          </div>
          <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
        </div>
      </section> */}

      <section className="hero">
        <div className="container">
          <div className="hero__img">
            <img src="/images/heroicon.png" alt="" height={80} width={80} />
          </div>
          <div className="hero__header mt-4">
            <h2>What does <br /> the future look like</h2>
          </div>
          <div className="hero__paragrapgh mt-4">
            <p>The next big feature slated for release is a tightly integrated Staff & Plant management module that leverages the platform to provide customised services for contractors on a project by project basis. 
              <br/>We are just getting started and there are many more features in the works including electrical work management, civil work management and safety management.</p>
          </div>
        </div>
      </section>
      <ContactUs/>
      <Footer />
    </>
  )
}

function reveal() {
  var reveals = document.querySelectorAll(".reveal");

  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 150;

    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active");
    } else {
      reveals[i].classList.remove("active");
    }
  }
}

window.addEventListener("scroll", reveal);
